<script lang="ts">
  let { grade = '?' }: { grade?: string | null } = $props();
  const g = $derived(grade ?? '?');
  const tone = $derived('AB'.includes(g) ? 'var(--ok)' : 'CD'.includes(g) ? 'var(--warn)' : g === '?' ? 'var(--muted)' : 'var(--bad)');
</script>

<span class="badge" style="--tone: {tone}" aria-label="Note de réactivité {g}">{g}</span>

<style>
  .badge {
    display: inline-grid;
    place-items: center;
    width: 2.8rem;
    height: 2.8rem;
    border-radius: 14px;
    font-family: var(--font-display);
    font-weight: 700;
    font-size: 1.5rem;
    color: var(--tone);
    border: 2px solid var(--tone);
    background: color-mix(in oklab, var(--tone) 12%, transparent);
    box-shadow: 0 0 22px -4px var(--tone), inset 0 0 12px -4px var(--tone);
  }
</style>
